import { IDataReducer } from '../../models/generals/iDataReducer';
import AuthClass, { IAuth } from '../../models/redux/iAuth';

import {
  UPDATE_AUTHORIZATIONS,
  UPDATE_AUTH_LOGOUT,
  UPDATE_AUTH_USER,
  UPDATE_GROUPS,
  UPDATE_NAVIGATIONMENU,
  UPDATE_PROJECTS,
  UPDATE_SECTIONS_COLUMNS_WIDGETS,
  UPDATE_WIDGETS,
  SHOULD_LOAD_CONFIGURATIONS,
} from '../../constants/ActionTypes';
import {
  getAuthorizations,
  getAuthUser,
  getNavigationMenu,
  getSectionsColumns,
  getWidgets,
  getGroups,
  RemoveCredentialsApp,
  setAuthorizations,
  setAuthUser,
  setNavigationMenu,
  setSectionsColumns,
  setWidgets,
  setGroups,
  setProjects,
  getProjects,
  RemoveConfigurations,
} from '@helpers/utils';

const INIT_STATE = new AuthClass(
  getAuthUser(),
  getAuthorizations(),
  getNavigationMenu(),
  getWidgets(),
  getSectionsColumns(),
  getGroups(),
  getProjects(),
);

export default (state = INIT_STATE, action: IDataReducer): IAuth => {
  switch (action.type) {
    case UPDATE_AUTH_LOGOUT: {
      RemoveCredentialsApp();
      return new AuthClass();
    }

    case UPDATE_AUTH_USER: {
      setAuthUser(action.user);
      return {
        ...state,
        authUser: action.user ?? null,
      };
    }
    case SHOULD_LOAD_CONFIGURATIONS: {
      const currentUser = getAuthUser();
      currentUser.should_load_configurations = true;
      setAuthUser(currentUser);
      return {
        ...state,
        authUser: currentUser ?? null,
      };
    }
    case UPDATE_AUTHORIZATIONS: {
      setAuthorizations(action.authorizations);
      return {
        ...state,
        authorizations: action.authorizations ?? null,
      };
    }

    case UPDATE_NAVIGATIONMENU: {
      setNavigationMenu(action.navigationMenu);
      return {
        ...state,
        navigationMenu: action.navigationMenu ?? null,
      };
    }

    case UPDATE_WIDGETS: {
      setWidgets(action.widgets);
      return {
        ...state,
        widgets: action.widgets,
      };
    }

    case UPDATE_GROUPS: {
      setGroups(action.groups);
      return {
        ...state,
        groups: action.groups,
      };
    }

    case UPDATE_SECTIONS_COLUMNS_WIDGETS: {
      setSectionsColumns(action.sectionsColumns);
      return {
        ...state,
        sectionsColumns: action.sectionsColumns,
      };
    }
    case UPDATE_PROJECTS: {
      setProjects(action.projects);
      return {
        ...state,
        projects: action.projects,
      };
    }
    default:
      return state;
  }
};
